import { AnalyticsEvent } from "../models";

export class ChipotleUOnboardingPageLoadEvent implements AnalyticsEvent {
    name = "ChipotleUOnboardingPageLoadEvent";
    constructor(public readonly slideNumber: number) {}
}